import React, { forwardRef, useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import stylePropType from 'react-style-proptype';
import styled from 'styled-components';

import { Cell, Text } from '../../atoms';
import { DropdownContext } from '../../organisms/Dropdown/DropdownContext';

const StyledText = styled(Text)`
  display: inline-block;
  align-items: center;

  text-decoration: none;
  border: 0;
  background: transparent;

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
  width: 100%;
`;

const StyledCell = styled(Cell)`
  flex-grow: 1;
  color: var(--content-body);
`;

const DropdownMenuItem = forwardRef(
  (
    {
      onClick = null,
      className = null,
      style = null,
      children = null,
      color = null,
      selected = false,
      leftIcon = null,
      rightIcon = null,
      shouldCloseMenu = true,
      ...rest
    },
    forwardedRef
  ) => {
    const dropdownMenuContext = useContext(DropdownContext);

    const handleClick = useCallback(
      (evt) => {
        if (onClick) onClick(evt);

        if (shouldCloseMenu) dropdownMenuContext?.closeMenu?.call();
      },
      [onClick, shouldCloseMenu]
    );

    return (
      <StyledCell
        $selected={selected}
        className={className}
        style={style}
        onClick={handleClick}
        {...rest}
      >
        {leftIcon}
        <StyledText as='span' ref={forwardedRef} $color={color}>
          {children}
        </StyledText>
        {rightIcon}
      </StyledCell>
    );
  }
);

DropdownMenuItem.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  className: PropTypes.string,
  color: PropTypes.string,
  style: stylePropType,
  selected: PropTypes.bool,
  leftIcon: PropTypes.PropTypes.node,
  rightIcon: PropTypes.PropTypes.node,
  shouldCloseMenu: PropTypes.bool
};

export { DropdownMenuItem };
